import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Reveal from "./Reveal";
import { useGo } from "./Nav";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TABS = ["All", "Living", "Dining", "Bedroom", "Décor"];

export default function Shop({ onBook }) {
  const go = useGo();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [tab, setTab] = useState("All");

  useEffect(() => {
    axios.get(`${API}/products`).then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  const shown = tab === "All" ? products : products.filter((p) => p.category === tab);

  return (
    <section id="shop" data-testid="shop-section" className="bg-cream py-28 md:py-40">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-8">
            <div>
              <p className="text-oxblood text-xs tracking-[0.45em] uppercase mb-6">The Collection</p>
              <h2 className="font-display text-oxblood-ink text-4xl md:text-6xl leading-tight max-w-2xl">
                Pieces ready to <em className="text-oxblood font-light">book today.</em>
              </h2>
            </div>
            <div className="flex flex-wrap gap-2" data-testid="shop-tabs">
              {TABS.map((t) => (
                <button
                  key={t}
                  data-testid={`shop-tab-${t.toLowerCase()}`}
                  onClick={() => setTab(t)}
                  className={`px-6 py-3 text-xs tracking-[0.22em] uppercase border transition-colors duration-300 ${
                    tab === t ? "bg-oxblood text-ivory border-oxblood" : "border-oxblood/30 text-oxblood hover:border-brass"
                  }`}
                >
                  {t}
                </button>
              ))}
            </div>
          </div>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {shown.map((p, i) => (
            <Reveal key={p.id || p.name} delay={i * 0.04}>
              <article
                data-testid={`product-card-${i}`}
                className="group bg-ivory border border-oxblood/15 hover:border-brass/70 transition-colors duration-500 flex flex-col h-full"
              >
                <div className="relative overflow-hidden aspect-[4/3] cursor-pointer" onClick={() => navigate(`/product/${p.id}`)}>
                  <img
                    src={p.image}
                    alt={p.name}
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <span className="absolute top-4 left-4 bg-oxblood-ink/80 text-ivory text-[10px] tracking-[0.3em] uppercase px-3 py-1.5">
                    {p.category}
                  </span>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 data-testid={`product-name-${i}`} onClick={() => navigate(`/product/${p.id}`)} className="font-display text-oxblood-ink text-2xl leading-snug cursor-pointer hover:text-oxblood transition-colors duration-300">{p.name}</h3>
                  <p className="mt-2 text-ink/55 font-light text-sm leading-relaxed flex-1">{p.description}</p>
                  <div className="mt-6 flex items-center justify-between gap-3">
                    <span className="font-display text-oxblood text-xl whitespace-nowrap">
                      ₹{Number(p.price).toLocaleString("en-IN")}
                    </span>
                    <button
                      data-testid={`product-book-${i}`}
                      onClick={() => { onBook(p.name); go("book"); }}
                      className="border border-oxblood text-oxblood hover:bg-oxblood hover:text-ivory text-[10px] tracking-[0.22em] uppercase px-4 py-2.5 transition-colors duration-300 whitespace-nowrap"
                    >
                      Book This Piece
                    </button>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-12 text-center text-ink/50 font-light text-sm">
            Every piece is made to order in our own factory — final pricing is confirmed on a call after you book.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
